<div class="container">
    <!-- Header usando componente shared -->
    <app-page-header
        title="Lista de Supresión SES"
        subtitle="Gestiona los correos bloqueados"
        icon="email">
    </app-page-header>

    <!-- Card principal -->
    <div class="main-card">
        <nav class="tabs-container">
            <div class="tabs-content">
                <a class="tab-item"
                    [ngClass]="{ 'tab-item-active': activeTab === 'consult', 'tab-item-inactive': activeTab !== 'consult' }"
                    (click)="setActiveTab('consult')" 
                    tabindex="0"
                    role="tab"
                    [attr.aria-selected]="activeTab === 'consult'">
                    <div class="tab-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="11" cy="11" r="8"/>
                            <path d="M21 21l-4.35-4.35"/>
                        </svg>
                    </div>
                    <div class="tab-content">
                        <span class="tab-title">Consultar Email</span>
                        <span class="tab-description">Verifica el estado de bloqueo</span>
                    </div>
                </a>
                
                <a class="tab-item"
                    [ngClass]="{ 'tab-item-active': activeTab === 'delete', 'tab-item-inactive': activeTab !== 'delete' }"
                    (click)="setActiveTab('delete')" 
                    tabindex="0"
                    role="tab"
                    [attr.aria-selected]="activeTab === 'delete'">
                    <div class="tab-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="3 6 5 6 21 6"/>
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                            <line x1="10" y1="11" x2="10" y2="17"/>
                            <line x1="14" y1="11" x2="14" y2="17"/>
                        </svg>
                    </div>
                    <div class="tab-content">
                        <span class="tab-title">Eliminar de Lista</span>
                        <span class="tab-description">Remover email de supresión</span>
                    </div>
                </a>
            </div>
        </nav>

        <div class="content" role="tabpanel">
            <div *ngIf="activeTab === 'consult'; else templateDelete" class="fade-in">
                <app-crc-getsuppressed-email></app-crc-getsuppressed-email>
            </div>
            <ng-template #templateDelete>
                <div class="fade-in">
                    <app-deletesuppressed-email></app-deletesuppressed-email>
                </div>
            </ng-template>
        </div>
    </div>
</div>